import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { BaContactsListComponent } from './contacts-list/contacts-list.component';
import { BaSharedInboxesComponent } from './shared-inboxes/shared-inboxes.component';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonModule } from 'primeng/button';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputNumberModule } from 'primeng/inputnumber';
import { PopoverModule } from 'primeng/popover';
import { SelectButtonModule } from 'primeng/selectbutton';

@Component({
    selector: 'pcg-ba-contacts',
    standalone: true,
    imports: [
        BaContactsListComponent,
        BaSharedInboxesComponent,
        FormsModule,
        ButtonModule,
        FloatLabelModule,
        SelectButtonModule,
        InputNumberModule,
        PopoverModule,
        FontAwesomeModule
    ],
    templateUrl: './contacts.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./contacts.component.scss']
})
export class BaContactsComponent {
    //#region View Childs
    @ViewChild("availableTable") availableTable: BaContactsListComponent;
    @ViewChild("selectedTable") selectedTable: BaContactsListComponent;
    //#endregion

    /** When toggle a contact update both tables */
    updateTable() {
        this.selectedTable.getContactList();
        this.availableTable.getContactList();
    }
}